import { useSelector } from "react-redux";
import { FixMeLater } from "types";
import { useContext } from "react";
import { AvoContext } from "analytics/AvoProvider";
import { useHistory } from "react-router-dom";
import { sharedLib } from "@shared/services/shared.service";

const useLogout = (): [() => Promise<FixMeLater>, { isLoading?: boolean }] => {
  const { avo } = useContext(AvoContext);
  const history = useHistory();
  const user = useSelector(sharedLib.selectors.authentication.selectUser);
  const refreshToken = useSelector(
    sharedLib.selectors.authentication.selectRefreshToken
  );
  const [logout, logoutStatus] =
    sharedLib.sharedApi.authentication.useLogoutMutation();

  const handleLogout = (): Promise<FixMeLater> => {
    return logout({ refresh_token: refreshToken }).then(() => {
      history.push("/");
      try {
        if (user?.should_track) {
          avo?.userLoggedOut({});
        }
      } catch {}
    });
  };

  return [handleLogout, logoutStatus];
};

export default useLogout;
